import React from 'react';
//import _get from 'lodash/get';
import './style.css';
import Button from 'components/Button/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
//import Badge from 'react-bootstrap/Badge';
import Carousel from "react-bootstrap/Carousel";
//import { user_access_level, user_Status } from "Api/Api";
import { NavLink } from "react-router-dom";
//import { local_routes } from 'utils/Routes';

class ManageBanner extends React.Component {
    render() {
        const { carousel_images, entity_name, back_link } = this.props;
        return (
            <div className="main-section">
                <React.Fragment>
                    {
                        carousel_images.length > 0 ?
                            <Carousel fade={true} pause={'hover'} controls={false} indicators={false} interval={5000}>
                                {
                                    this.props.carousel_images.map((img, i) => {
                                        let url = img;
                                        let array = url.split("/");
                                        //const convImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_1400x400/${array[5]}`;
                                        const convImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/transparent_1600x400/${array[5]}`;
                                        return (
                                            <Carousel.Item key={i} className="fade-carousel" style={{ height: '100%' }}>
                                                <div className="eventImage city-new-image" style={{ marginBottom: "0px", minHeight: '350px', backgroundImage: "url(" + convImg + ")" }}>
                                                    <div className="container">
                                                        <div className="row">
                                                            <Col sm={12} md={12} lg={12}>
                                                                <Row className="align-items-center">
                                                                    <Col md={7} lg={5}>
                                                                        {/* event-cover */}
                                                                        <div className="city-detail">
                                                                            <h1 style={{ marginTop: "80px" }} >{this.props.entity_name}</h1>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            
                                                            { back_link &&
                                                                <Col md={5} lg={4} className="ml-auto">
                                                                    <NavLink to={back_link}>
                                                                        <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                                                            Back
                                                                        </Button>
                                                                    </NavLink>                                                            
                                                                </Col>
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </Carousel.Item>
                                        )
                                    }
                                    )
                                }
                            </Carousel>
                            :
                            <div className="eventImage city-new-image" style={{ backgroundColor: "#343E48" }}>
                                <div className="container">
                                    <div className="row">
                                        <Col sm={12} md={12} lg={12}>
                                            <Row className="align-items-center">
                                                <Col md={7} lg={5}>
                                                    {/* event-cover */}
                                                    <div className="city-detail">
                                                        <h1>{entity_name}</h1>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </div>
                                </div>
                            </div>
                    }

                    {/* Banner section Ends */}
                </React.Fragment>
            </div>
        )
    }
}

export default ManageBanner;
